import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrendingUp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	...props,
	children: [/* @__PURE__ */ _jsx("polyline", { points: "3 17 9.5 10.5 13.5 14.5 21 7" }), /* @__PURE__ */ _jsx("polyline", { points: "15 7 21 7 21 13" })]
});
export default SvgTrendingUp;
